module.exports = __webpack_public_path__ + "static/media/cta-business-clarity.ef5347a7.webp";